import React from "react";
import { Briefcase, Eye, Inbox, Layers, Target } from "lucide-react";

type EnquirySummaryProps = {
    total: number;
    services: number;
    careers: number;
    leads: number;
    visible: number;
};

type StatCardProps = {
    label: string;
    value: number;
    icon: React.ReactNode;
    accent: string;
};

const StatCard = ({ label, value, icon, accent }: StatCardProps) => (
    <div className="rounded-xl border border-gray-200/80 bg-white p-4 shadow-sm transition hover:shadow-md">
        <div className="flex items-start justify-between gap-3">
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
                <p className="mt-2 text-3xl font-bold text-gray-900">{value}</p>
            </div>
            <div className={`rounded-xl p-2.5 ${accent}`}>{icon}</div>
        </div>
    </div>
);

export const EnquirySummary = ({ total, services, careers, leads, visible }: EnquirySummaryProps) => (
    <div className="mb-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        <StatCard
            label="Total"
            value={total}
            icon={<Inbox className="h-5 w-5 text-violet-700" />}
            accent="bg-violet-100"
        />
        <StatCard
            label="Services"
            value={services}
            icon={<Layers className="h-5 w-5 text-sky-700" />}
            accent="bg-sky-100"
        />
        <StatCard
            label="Careers"
            value={careers}
            icon={<Briefcase className="h-5 w-5 text-indigo-700" />}
            accent="bg-indigo-100"
        />
        <StatCard
            label="Leads"
            value={leads}
            icon={<Target className="h-5 w-5 text-amber-700" />}
            accent="bg-amber-100"
        />
        <StatCard
            label="Filtered"
            value={visible}
            icon={<Eye className="h-5 w-5 text-emerald-700" />}
            accent="bg-emerald-100"
        />
    </div>
);
